import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Routes from "./components/Routes";
import { TranslationProvider } from "./hooks/use-translation";
import { LoadingProvider } from "./hooks/use-loader";
import { SnackBarProvider } from "./hooks/use-snackbar";
// import SnackBar from './components/snackbar';
import CacheBuster from "./components/CacheBuster";
import { Provider } from "react-redux";
import { createStore } from "redux";
import rootReducer from "./reducers/Reducer";
const relativePath = "/survey";
const store = createStore(rootReducer);

export default () => (
    <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return null;
            if (!loading && !isLatestVersion) {
                refreshCacheAndReload();
            }

            return (
                <>
                    <Provider store={store}>
                        <LoadingProvider>
                            <TranslationProvider>
                                <SnackBarProvider>
                                    <Router basename={relativePath}>
                                        <Routes />
                                    </Router>
                                </SnackBarProvider>
                            </TranslationProvider>
                        </LoadingProvider>
                    </Provider>
                </>
            );
        }}
    </CacheBuster>
);
